import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import FormattedText from '../../../../../../common/formatted-text'

type MessageProps = {
    from: From
    message: string
    picture: string
}

type From = 'user' | 'byzans'

const Message: React.FunctionComponent<MessageProps> = ({ from, message, picture }) => (
    <Container from={from}>
        <User from={from}>
            <Image src={picture} />
        </User>
        <Bubble from={from}>
            <FormattedText text={message} />
            <Pointer from={from}>
                <svg height={30} width={30}>
                    <path d={`
                        M 0 0
                        A 30 30 0 0 0 30 30 
                        A 50 50 0 0 1 20 0 
                        M 0 0
                    `} />
                </svg>
            </Pointer>
        </Bubble>
    </Container>
)

const Container = styled.div<{ from: From }>`
    display: grid;
    width: 100%;

    grid-template-columns: ${p => isUser(p.from) ? 'auto 1fr' : '1fr auto'};
    align-items: flex-end;

    grid-gap: 15px;
`

const User = styled.div<{ from: From }>`
    width: 38px;
    height: 38px;

    border-radius: 50%;
    overflow: hidden;

    grid-column: ${p => isUser(p.from) ? '1' : '2'};
    grid-row: 1;
`

const Image = styled.img`
    width: 100%;
    height: 100%;
`

const Bubble = styled.div<{ from: From }>`
    position: relative;

    padding: 14px 20px;
    
    font-size: 16px;
    font-weight: bold;
    color: ${p => isUser(p.from) ? p.theme.colors.main : p.theme.colors.bg};

    border-radius: 20px;
    background: ${p => isUser(p.from) ? p.theme.colors.bgHushed : p.theme.colors.accent};

    grid-column: ${p => isUser(p.from) ? '2' : '1'};
    grid-row: 1;

    ${up('mobileBig')} {
        font-size: 20px;
        padding: 14px 22px;
    }

    ${up('tablet')} {
        font-size: 30px;
        padding: 22px 35px;
    }
`

const Pointer = styled.div<{ from: From }>`
    position: absolute;
    ${p => isUser(p.from) ? 'left' : 'right' }: -10px;
    bottom: 0;

    height: fit-content;
    height: 30px;

    transform: scaleX(${p => isUser(p.from) ? -1 : 1});

    & path {
      fill: ${p => isUser(p.from) ? p.theme.colors.bgHushed : p.theme.colors.accent };
    }
`

const isUser = (from: From) => from === 'user'

export default Message